import { environment } from "src/environments/environment";

// const baseUrl = "https://masterpro.mhada.gov.in";
const baseUrl = environment.MASTER_URL;
// const baseUrl = "https://masterpro.mhada.gov.in";
//const grievanceServerUrl =
// ("https://grievancebackendprod.mhada.gov.in/secure/grievance"); //production

const grievanceServerUrl = environment.GRIEVANCE_URL;


  //"http://localhost:38088/secure/grievance";
  // "https://demogrievanceservice.mhada.gov.in/secure/grievance"; //demo
// const grievanceServerUrl="http://192.168.1.100:38088/secure/grievance"

export const ApiUrls = {
  login: `${baseUrl}/open/login`,

  otpVerification: `${baseUrl}/open/otp-verification`,

  resendOtp: `${baseUrl}/open/resend-otp`,

  home: `${baseUrl}/secure/home/dashboard`,

  dashboard: `${baseUrl}/secure/dashboard`,
  lotterywisedashboard: `${baseUrl}/secure/lotterywise-dashboard/{lotteryKey}`,
  schemewisedashboard: `${baseUrl}/secure/schemewise-dashboard/{schemekey}`,

  countDashboard: `${baseUrl}/secure/countDashboard`,

  //NocPending Count
  nocPendingCount: `${baseUrl}/secure/nocPendingCount/nocPendingCountDashboard`,
  nocDashboard: `${baseUrl}/secure/home/noc-dashboard`,
  assignModerationCasesUrl: `${baseUrl}/secure/home/assign-moderation-cases`,
  releaseModerationCasesUrl: `${baseUrl}/secure/home/release-moderation-cases/{userId}`,

  moderationList: `${baseUrl}/secure/moderation/list`,
  moderationDetail: `${baseUrl}/secure/moderation/{registrationModerationKey}`,
  findMLPendingDocuments: `${baseUrl}/secure/moderation/ml-pending/{pan}`,

  queryExecutorList: `${baseUrl}/secure/reports/query-exec/list`,
  initQueryExecutorFormUrl: `${baseUrl}/secure/reports/query-exec/form`,
  getBoardsListUrl: `${baseUrl}/secure/reports/boardLists/boards/list/fetch`,
  queryExecutorDetail: `${baseUrl}/secure/reports/query-exec/{queryExecutorKey}`,
  saveQueryExecutor: `${baseUrl}/secure/reports/query-exec`,
  updateQueryExecutor: `${baseUrl}/secure/reports/query-exec/{queryExecutorKey}`,
  toggleActivationQueryExecutorUrl: `${baseUrl}/secure/reports/query-exec/{queryExecutorKey}`,

  boardDocumentsList: `${baseUrl}/secure/board-documents/list`,
  initBoardDocumentsFormUrl: `${baseUrl}/secure/board-documents/form`,
  boardDocumentDetail: `${baseUrl}/secure/board-documents/{key}`,
  saveBoardDocument: `${baseUrl}/secure/board-documents`,
  updateBoardDocument: `${baseUrl}/secure/board-documents/{key}`,
  toggleActivationBoardDocumentUrl: `${baseUrl}/secure/board-documents/{key}`,

  proApproverList: `${baseUrl}/secure/pro-approver/list`,
  proApproverDetail: `${baseUrl}/secure/pro-approver/{certJournalistKey}`,
  fetchEsignReceipt: `${baseUrl}/secure/pro-approver/esign-cert/{certJournalistKey}`,

  casteValRefLetterApproverList: `${baseUrl}/secure/estate-manager/caste-validity-ref-letter/list`,
  casteValRefLetterApproverDetail: `${baseUrl}/secure/estate-manager/caste-validity-ref-letter/{key}`,
  casteValRefLetterFetchEsignReceipt: `${baseUrl}/secure/estate-manager/caste-validity-ref-letter/esign-cert/{key}`,

  esignReceipt: `${baseUrl}/secure/verify-esign/{esignType}/{key}`,

  roleList: `${baseUrl}/secure/roles`,
  initRoleFormUrl: `${baseUrl}/secure/roles/form`,
  getRoleByKeyUrl: `${baseUrl}/secure/roles/{roleKey}`,
  saveRole: `${baseUrl}/secure/roles`,
  updateRoleUrl: `${baseUrl}/secure/roles/{roleKey}`,
  toggleActivationRoleUrl: `${baseUrl}/secure/roles/{roleKey}`,

  toggleActivationProjectUrl: `${baseUrl}/secure/projects/{projectKey}`,
  toggleActivationAmenityUrl: `${baseUrl}/secure/amenity/{amenityKey}`,
  toggleActivationFinancialYearUrl: `${baseUrl}/secure/financial-year/{financialYearKey}`,

  userList: `${baseUrl}/secure/users`,
  initUserFormUrl: `${baseUrl}/secure/users/form`,
  getUserByKeyUrl: `${baseUrl}/secure/users/{userKey}`,
  saveUser: `${baseUrl}/secure/users`,
  updateUserUrl: `${baseUrl}/secure/users/{userKey}`,
  updateSopMasterUrl: `${baseUrl}/secure/sopMaster/{key}`,
  updateDefaultPasswordUrl: `${baseUrl}/secure/users/default-password`,
  toggleActivationUserUrl: `${baseUrl}/secure/users/{userKey}`,
  deleteSop: `${baseUrl}/secure/sopMaster/{key}`,

  deactiveSopSteps: `${baseUrl}/secure/sopMaster/steps/{key}`,
  deactiveSopSubSteps: `${baseUrl}/secure/sopMaster/sub-steps/{key}`,

  resetUserPasswordUrl: `${baseUrl}/secure/users/reset-password/{userKey}`,
  saveSopMaster: `${baseUrl}/secure/sopMaster`,

  paymentReconSearch: `${baseUrl}/secure/reconciliation/search`,
  paymentReconByTransaction: `${baseUrl}/secure/reconciliation/search/{transactionId}`,
  pendingTransactions: `${baseUrl}/secure/reconciliation/pending-transactions`,

  organizationList: `${baseUrl}/secure/organizations`,
  getOrgByKeyUrl: `${baseUrl}/secure/organizations/{organizationKey}`,
  saveOrg: `${baseUrl}/secure/organizations`,
  updateOrgUrl: `${baseUrl}/secure/organizations/{organizationKey}`,
  activeDactiveOrgUrl: `${baseUrl}/secure/organizations/{organizationKey}`,

  boardList: `${baseUrl}/secure/board`,
  getBoardByKeyUrl: `${baseUrl}/secure/board/{boardKey}`,
  saveBoard: `${baseUrl}/secure/board`,
  initBoardForm: `${baseUrl}/secure/board/form`,
  updateBoardUrl: `${baseUrl}/secure/board/{boardKey}`,
  activeDactiveBoardUrl: `${baseUrl}/secure/board/{boardKey}`,

  featureList: `${baseUrl}/secure/features`,
  initFeatureFormUrl: `${baseUrl}/secure/features/form`,
  getFeatureByKeyUrl: `${baseUrl}/secure/features/{featureKey}`,
  saveFeature: `${baseUrl}/secure/features`,
  updateFeatureUrl: `${baseUrl}/secure/features/{featureKey}`,
  toggleActivationFeatureUrl: `${baseUrl}/secure/features/{featureKey}`,

  importMasterInitFormUrl: `${baseUrl}/secure/import/master/init`,
  importMasterUrl: `${baseUrl}/secure/import/master/{lotteryKey}/{type}`,
  downloadTemplateUrl: `${baseUrl}/secure/import/master/template/{type}`,
  exportAppsInitFormUrl: `${baseUrl}/secure/export-apps`,
  exportPhotosInitFormUrl: `${baseUrl}/secure/export-photos`,
  fetchBatchWiseLotteryPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}`,
  importLetterrInitFormUrl: `${baseUrl}/secure/import/letter/init`,
  importLetterrUrl: `${baseUrl}/secure/import/letter/{lotteryKey}/{type}`,

  downloadPolUrl: `${baseUrl}/secure/export-pol/{applicationNo}`,

  importResultsInitFormUrl: `${baseUrl}/secure/import-results`,
  exportAppsUrl: `${baseUrl}/secure/export-apps/{lotteryKey}`,
  importResultsUrl: `${baseUrl}/secure/import-results/{lotteryKey}`,
  downloadENCUrl: `${baseUrl}/secure/export-apps/{key}/enc`,
  downloadPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}/{batchName}/{start}/{end}`,
  printExportApplicationsHashCodeUrl: `${baseUrl}/secure/export-apps/{key}/print-hashcode`,

  installmentConfigInitFormUrl: `${baseUrl}/secure/installment-config/init`,
  installmentConfigInitWithLotteryUrl: `${baseUrl}/secure/installment-config/init/{lotteryKey}`,
  viewinstallmentConfigInitWithLotteryUrl: `${baseUrl}/secure/installment-config/view/{lotteryKey}/{installmentType}`,
  viewinstallmentConfigInitWithSchemeUrl: `${baseUrl}/secure/installment-config/view/{lotteryKey}/{schemeKey}/{installmentType}`,

  extendAcceptanceInitFormUrl: `${baseUrl}/secure/extendAcceptance/init`,
  extendAcceptanceInitWithLotteryUrl: `${baseUrl}/secure/extendAcceptance/init/{lotteryKey}`,
  getLotteryandSchemeData: `${baseUrl}/secure/extendAcceptance/initWithLotteryAndScheme`,
  updateAcceptanceDtl: `${baseUrl}/secure/extendAcceptance/updateAcceptanceDtl`,
  // installmentConfigInitWithLotteryEditUrl: `${baseUrl}/secure/installment-config/get/{installmentType}/{lotteryKey}/{lotteryInstKey}`,
  // installmentConfigInitWithSchemeEditUrl: `${baseUrl}/secure/installment-config/get/{installmentType}/{lotteryKey}/{schemeInstKey}`,

  installmentConfigSaveWithLotteryUrl: `${baseUrl}/secure/installment-config/save/{lotteryKey}`,
  installmentConfigInitWithSchemeUrl: `${baseUrl}/secure/installment-config/init/{lotteryKey}/{schemeKey}`,
  installmentConfigSaveWithSchemeUrl: `${baseUrl}/secure/installment-config/save/{lotteryKey}/{schemeKey}`,

  reportInitFormUrl: `${baseUrl}/secure/reports/init`,
  generateReportUrl: `${baseUrl}/secure/reports/{selectedReport}`,
  generateReportWithStartDateAndEndDateUrl: `${baseUrl}/secure/reports/settlementReport/{selectedReport}`,

  //queryExecutorReportUrl: `${baseUrl}/secure/reports/query/{selectedReport}`,
  //queryExecutorReportUrl1: `${baseUrl}/secure/reports/query/{selectedReport}/{boardKey}/{multiSelectedLottery}`,
  queryExecutorReportUrl: `${baseUrl}/secure/reports/query/{selectedReport}/{boardKey}/{multiSelectedLottery}`,
  queryExecutorReportUrl1: `${baseUrl}/secure/reports/query/{selectedReport}/{boardKey}/{multiSelectedLottery}`,

  shiftTenementsInitFormUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/init`,
  fetchShiftTenementStatusForLotteryUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/fetch-shift-tenement-status/{lotteryKey}`,
  shiftTenementForLotteryUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/shift-tenements/{lotteryKey}`,
  approveShiftTenementStatusForLotteryUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/approve-shifted-tenements/{lotteryKey}`,
  generateShiftingTenementSummaryUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/shifted-summary/{lotteryKey}`,

  // exportAppsInitFormUrl: `${baseUrl}/secure/export-apps`,
  // exportPhotosInitFormUrl: `${baseUrl}/secure/export-photos`,
  // fetchBatchWiseLotteryPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}`,
  // importResultsInitFormUrl: `${baseUrl}/secure/import-results`,
  // exportAppsUrl: `${baseUrl}/secure/export-apps/{lotteryKey}`,
  // importResultsUrl: `${baseUrl}/secure/import-results/{lotteryKey}`,
  // downloadENCUrl: `${baseUrl}/secure/export-apps/{key}/enc`,
  // downloadPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}/{batchName}/{start}/{end}`,
  // printExportApplicationsHashCodeUrl: `${baseUrl}/secure/export-apps/{key}/print-hashcode`,

  menuForLoggedInUserUrl: `${baseUrl}/secure/menu`,
  getSopMaster: `${baseUrl}/secure/sopMaster`,
  lotteryList: `${baseUrl}/secure/lottery`,
  newLotteryList: `${baseUrl}/secure/new-lottery`,
  getLotteryByKeyUrl: `${baseUrl}/secure/lottery/{lotteryKey}`,
  saveLottery: `${baseUrl}/secure/lottery`,
  saveNewLottery: `${baseUrl}/secure/new-lottery`,
  initLotteryForm: `${baseUrl}/secure/lottery/form`,
  initNewLotteryForm: `${baseUrl}/secure/new-lottery/form`,
  initSopMasterForm: `${baseUrl}/secure/sopMaster/{key}`,
  updatelotteryUrl: `${baseUrl}/secure/lottery/{lotteryKey}`,
  updateNewlotteryUrl: `${baseUrl}/secure/new-lottery/{lotteryKey}`,
  activeDactiveLotteryUrl: `${baseUrl}/secure/lottery/{lotteryKey}`,
  activeDactiveNewLotteryUrl: `${baseUrl}/secure/new-lottery/{lotteryKey}`,
  genereteDraftListUrl: `${baseUrl}/secure/lottery/genereteDraftList/{lotteryKey}`,
  generateBulkLoiUrl: `${baseUrl}/secure/lottery/generateBulkLoi/{lotteryKey}`,
  generateAgrmntLtr: `${baseUrl}/secure/letters/generate-agreement-letter/{applicationNo}`,
  uploadAgrmntNIndxLtr: `${baseUrl}/secure/letters/upload-agrmntNIndx-letter/{uploadedFileType}/{applicationNo}`,
  callCenterSearch: `${baseUrl}/secure/call-center/search`,
  callCenterView: `${baseUrl}/secure/call-center/{registrationId}`,
  generateHashcodeReportUrl: `${baseUrl}/secure/lottery/master_and_application_hash/{lotteryKey}`,

  signOffReportListUrl: `${baseUrl}/secure/signoff-report/list`,
  initSignedOffUrl: `${baseUrl}/secure/signoff-report/init`,
  createRquestSigneOffUrl: `${baseUrl}/secure/signoff-report/create-request/{reportType}`,
  checkStatusUrl: `${baseUrl}/secure/signoff-report/check-request-status/{key}`,
  downloadSignedOffUrl: `${baseUrl}/secure/signoff-report/download-signedoff-report/{key}`,
  downloadSignedOffAuditTrailUrl: `${baseUrl}/secure/signoff-report/download-audit-trail/{key}`,

  viewApplicationSearch: `${baseUrl}/secure/view-application/search`,
  viewApplicationSearchByAppNo: `${baseUrl}/secure/view-application/searchAppNumber`,
  viewApplicationDetail: `${baseUrl}/secure/view-application/{applicationId}`,
  fetchPOL: `${baseUrl}/secure/view-application/pol/{registrationId}/{applicationId}`,
  fetchLOI: `${baseUrl}/secure/view-application/loi/{registrationId}/{applicationNo}`,
  fetchAcknowledgement: `${baseUrl}/secure/view-application/acknowledgement/{registrationId}/{applicationId}`,
  fetchEmdReceipt: `${baseUrl}/secure/view-application/emd-receipt/{registrationId}/{applicationId}`,
  allLotteryList: `${baseUrl}/secure/lottery/all`,

  schemeList: `${baseUrl}/secure/schemes`,
  initSchemeFormUrl: `${baseUrl}/secure/schemes/form`,
  getSchemeByKeyUrl: `${baseUrl}/secure/schemes/{schemeKey}`,
  saveScheme: `${baseUrl}/secure/schemes`,
  updateSchemeUrl: `${baseUrl}/secure/schemes/{schemeKey}`,
  schemeImagesUrl: `${baseUrl}/open`,

  projectList: `${baseUrl}/secure/projects`,
  initProjectFormUrl: `${baseUrl}/secure/projects/form`,
  getProjectByKeyUrl: `${baseUrl}/secure/projects/{projectKey}`,
  saveProject: `${baseUrl}/secure/projects`,
  updateProjectUrl: `${baseUrl}/secure/projects/{projectKey}`,
  projectImagesUrl: `${baseUrl}/open`,

  amenityList: `${baseUrl}/secure/amenity`,
  getAmenityByKeyUrl: `${baseUrl}/secure/amenity/{amenityKey}`,
  saveAmenity: `${baseUrl}/secure/amenity`,
  updateAmenityUrl: `${baseUrl}/secure/amenity/{amenityKey}`,

  financialYearList: `${baseUrl}/secure/financial-year`,
  getFinancialYearByKeyUrl: `${baseUrl}/secure/financial-year/{financialYearKey}`,
  saveFinancialYear: `${baseUrl}/secure/financial-year`,
  updateFinancialYearUrl: `${baseUrl}/secure/financial-year/{financialYearKey}`,

  bankMasterList: `${baseUrl}/secure/banks`,
  initBankMasterFormUrl: `${baseUrl}/secure/banks/form`,
  getBankMasterByKeyUrl: `${baseUrl}/secure/banks/{bankKey}`,
  saveBankMaster: `${baseUrl}/secure/banks`,
  updateBankMasterUrl: `${baseUrl}/secure/banks/{bankKey}`,
  deleteBankMasterUrl: `${baseUrl}/secure/banks/{bankKey}`,

  //for grievance
  loadBoard: `${grievanceServerUrl}/loadBoards`,
  loadGrievanceBybdid: `${grievanceServerUrl}/loadGrievance`,
  isCheckDuplicateGrievance: `${grievanceServerUrl}/isDuplicateGrievance`,
  raiseGrievanceForMhadaUser: `${grievanceServerUrl}/createGrievanceForMhadaUser`,

  loadGrievanceForMhadaUser: `${grievanceServerUrl}/loadGrievanceForMhadaUser`,

  // loadGrievanceHistory: `${grievanceServerUrl}/loadGrievanceHistory`,

  loadGrievanceHistory: `${grievanceServerUrl}/loadGrievanceHistoryForAssigenedView`, //assigned grievance view
  loadMasterGrievanceHistory: `${grievanceServerUrl}/loadGrievanceHistoryForMasterView`, //load master grievance view
  loadSelfGrievanceHistory: `${grievanceServerUrl}/loadGrievanceHistoryForUserView`, //load self grievance view

  replyFromMhadaUser: `${grievanceServerUrl}/replyFromMhadaUser`,
  downloadFileForGrievance: `${grievanceServerUrl}/downloadFileForGrievanceV1`,
  close: `${grievanceServerUrl}/close`,
  reopen: `${grievanceServerUrl}/reopen`,
  replyFromInternalUser: `${grievanceServerUrl}/replyFromInternalUser`,
  loadStatus: `${grievanceServerUrl}/loadStatus`,

  loadDepartment: `${grievanceServerUrl}/loadDepartment`,
  loadUserByDepartment: `${grievanceServerUrl}/loadUserByDepartment`,
  loadGrievanceByDpid: `${grievanceServerUrl}/loadGrievanceByDpid`,
  updateGrievForTransfer: `${grievanceServerUrl}/updateGrievForTransfer`,
  loadForTransfer: `${grievanceServerUrl}/loadForTransfer`,
  loadGrievanceForSE: `${grievanceServerUrl}/loadGrievanceForSE`,

  createGrievanceType: `${grievanceServerUrl}/createGrievanceType`,
  loadGrievanceType: `${grievanceServerUrl}/loadGrievanceType`,
  getOneGrievanceType: `${grievanceServerUrl}/getOneGrievanceType`,
  updateGrievanceType: `${grievanceServerUrl}/updateGrievanceType`,
  deleteGrievanceType: `${grievanceServerUrl}/deleteGrievanceType`,

  loadAllGrievanceByDpId: `${grievanceServerUrl}/loadAllGrievanceByDpId`,
  selfAssigen: `${grievanceServerUrl}/selfAssigen`,

  listOfRegUser: `${grievanceServerUrl}/listOfRegUser`,
  loadChannel: `${grievanceServerUrl}/loadChannel`,
  createGrievanceForLotteryUserBySE: `${grievanceServerUrl}/createGrievanceForLotteryUserBySE`,
  listOfRegUserDetails: `${grievanceServerUrl}/listOfRegUserDetails`,
  loadLottery: `${grievanceServerUrl}/loadLottery`,
  loadApplication: `${grievanceServerUrl}/loadApplication`,
  loadOnlinePayment: `${grievanceServerUrl}/loadOnlinePayment`,

  isDuplicateGrievance: `${grievanceServerUrl}/isDuplicateGrievance`,

  verifyOtpForGrievance: `${grievanceServerUrl}/verifyOtpForGrievance`,
  resendOTP: `${grievanceServerUrl}/resendOTP`,
  loadGrievanceForReport: `${grievanceServerUrl}/loadGrievanceForReport`,

  createEscalationDuration: `${grievanceServerUrl}/createGrievanceEscalation`,
  deleteGrievanceEscalation: `${grievanceServerUrl}/deleteGrievanceEscalation`,
  updateGrievanceEscalation: `${grievanceServerUrl}/updateGrievanceEscalation`,
  getOneGrievanceEscalation: `${grievanceServerUrl}/getOneGrievanceEscalation`,
  getAllGrievanceEscalation: `${grievanceServerUrl}/getAllGrievanceEscalation`,

  createObjectionSuggestionType: `${grievanceServerUrl}/createObjectionSuggestionType`,
  loadObjectionAndSuggestionType: `${grievanceServerUrl}/loadObjectionAndSuggestionType`,
  deleteObjectionAndSuggestionType: `${grievanceServerUrl}/deleteOSType`,
  loadOneObjectionAndSuggestionType: `${grievanceServerUrl}/loadOneObjectionAndSuggestionType`,
  updateObjectionSuggestionType: `${grievanceServerUrl}/updateObjectionSuggestionType`,
  //

  loadOSForInternalUser: `${grievanceServerUrl}/loadOSForInternalUser`,
  loadOSHistory: `${grievanceServerUrl}/loadOSHistory`,
  loadOSStatus: `${grievanceServerUrl}/loadOSStatus`,
  objectionReplyFromInternalUser: `${grievanceServerUrl}/objectionReplyFromInternalUser`,
  loadOSForReport: `${grievanceServerUrl}/loadOSForReport`,

  loadForReport: `${grievanceServerUrl}/loadForReport`,
  loadOsTypeBybdid: `${grievanceServerUrl}/loadObjectionAndSuggestionTypeByDepId`,
  loadForOSReport: `${grievanceServerUrl}/loadForOSReport`,

  loadGrievanceForSEStatusWise: `${grievanceServerUrl}/loadGrievanceForSEStatusWise`,
  loadAllGrievanceByDpIdStatusWise: `${grievanceServerUrl}/loadAllGrievanceByDpIdStatusWise`,
  loadStatusForSearch: `${grievanceServerUrl}/loadStatusForSearch`,
  loadOSForInternalUserV2: `${grievanceServerUrl}/loadOSForInternalUserV2`,
  loadStatusForAssignedSearch: `${grievanceServerUrl}/loadStatusForAssignedSearch`,
  loadAllGrievanceById: `${grievanceServerUrl}/filterGrievance`,
  //Update Password
  updatePassword: `${baseUrl}/secure/change-password`,

  //for allocation-Group
  initallocateGroupForm: `${baseUrl}/secure/allocate-group/form`,
  getLotteryCategoryListByKeyUrl: `${baseUrl}/secure/allocate-group/{lotteryKey}`,
  saveAllocateGroup: `${baseUrl}/secure/allocate-group`,

  //For Announcement
  announcementList: `${baseUrl}/secure/announcement/list`,
  toggleActivationAnnouncementUrl: `${baseUrl}/secure/announcement/{announcementKey}`,
  saveAnnouncement: `${baseUrl}/secure/announcement`,
  initAnnouncementForm: `${baseUrl}/secure/announcement/form`,
  getAnnouncementByKeyUrl: `${baseUrl}/secure/announcement/{announcementKey}`,
  updateAnnouncementUrl: `${baseUrl}/secure/announcement/{announcementKey}`,

  //For Activate WailtList
  applicatntsList: `${baseUrl}/secure/activewaitlist`,
  initLotteryForActivateWaitlist: `${baseUrl}/secure/activewaitlist/init`,
  toggleActivateWaitList: `${baseUrl}/secure/activewaitlist/{applicationKey}/{wtlType}`,
  toggleActivateAllWaitList: `${baseUrl}/secure/activewaitlist/operateAll`,

  loadGrievanceTypeV2: `${grievanceServerUrl}/loadGrievanceTypeV2`,
  loadGrievanceByDpidV2: `${grievanceServerUrl}/loadGrievanceByDpidV2`,

  // For Sop
  fetchSopConfiguration: `${baseUrl}/secure/sopMaster/sop-management/{key}/{lotteryId}`,
  sopLotteryList: `${baseUrl}/secure/sopMaster/sop-management`,
  saveSopConfig: `${baseUrl}/secure/sopMaster/saveSop`,
  downloadSopUrl: `${baseUrl}/secure/sopMaster/download-sop/{key}`,
  downloadSopTemplateUrl: `${baseUrl}/secure/sopMaster/download-sop-template/{key}`,
  allLotteryListForSop: `${baseUrl}/secure/sopMaster/all`,

  generateDrawResultUrl: `${baseUrl}/secure/announcement/generateDrawResult/{lotteryKey}`,

  moderationAuditTrail: `${baseUrl}/secure/moderation/audit`,
  moderationDocumentAuditTrail: `${baseUrl}/secure/moderation/audit/{registrationId}`,
  // FOR POL

  generateBulkPOLUrl: `${baseUrl}/secure/lottery/generateBulkPOL/{lotteryKey}`,
  bulkPushToModerationJob: `${baseUrl}/open/api-jobs/scheduleBulkPushToModerationJob`,
  generateDomileModeration: `${baseUrl}/open/api-jobs/schedule`,
  generateSettlementPayment: `${baseUrl}/open/api-jobs/scheduleSettlementJob`,

  // For Noc Approval
  nocApproverList: `${baseUrl}/secure/noc-approver/list`,
  nocApproverDetail: `${baseUrl}/secure/noc-approver/{mortKey}`,
  cancelNoc: `${baseUrl}/secure/noc-approver/cancelNoc/{mortKey}/{applicationNo}`,
  rejectCancelNocRequest: `${baseUrl}/secure/noc-approver/rejectCancelNocRequest/{mortKey}/{applicationNo}`,
  fetchEsignReceiptNoc: `${baseUrl}/secure/noc-approver/esign-cert/{mortKey}`,

  //For Corrigendum Upload
  corrigendumApplicationSearch: `${baseUrl}/secure/corrigendum-upload/search`,
  viewCorrigendumDetail: `${baseUrl}/secure/corrigendum-upload/{applicationId}`,
  addCorrigendum: `${baseUrl}/secure/corrigendum-upload/save`,
  getCorrigendumDetails: `${baseUrl}/secure/corrigendum-upload/getCorrigendumDetails`,
  initCorrigendumDetails: `${baseUrl}/secure/corrigendum-upload/done/{key}`,
  deactivateCorrigendum: `${baseUrl}/secure/corrigendum-upload/{key}`,
  viewPdf: `${baseUrl}/secure/corrigendum-upload/open/{registrationId}/{document}`,
  downloadCorrigendum: `${baseUrl}/secure/corrigendum-upload/downloadCorrigendum/{key}`,
  //lotterywise corrigendum upload
  getSchemeApplicationFilterList: `${baseUrl}/secure/corrigendum-upload/FindSchemeApplicantList/{lotteryId}/{schemeId}`,
  uploadLotterywiseCorrigendum: `${baseUrl}/secure/corrigendum-upload/upload-Lotterywise-letter/{uploadedFileType}/{lotteryId}`,
  addCorrigendumForLottery: `${baseUrl}/secure/corrigendum-upload/saveLotteryWiseCorrigendum`,
  addCorrigendumForLotteryAndScheme: `${baseUrl}/secure/corrigendum-upload/saveSchemeWiseCorrigendum`,
  addCorrigendumForApplication: `${baseUrl}/secure/corrigendum-upload/saveCorrigendumForApplication`,
  addCorrigendumForSelectedApplication: `${baseUrl}/secure/corrigendum-upload/saveCorrigendumForSelected`,

  //Bulk email-sms-notification
  // downloadEmailSmsTemplateUrl: `${baseUrl}/secure/email-sms/template`,
  bulkEmailSmsUrl: `${baseUrl}/secure/email-sms-notification/bulk-email-sms`,
  finalBulkEmailSmsUrl: `${baseUrl}/secure/email-sms-notification/email-sms`,
  // initFileFormUrl: `${baseUrl}/secure/email-sms-notification/fileList`,
  fileList: `${baseUrl}/secure/email-sms-notification/fileTableList`,
  getPaymentRefundUploadFileList: `${baseUrl}/secure/refund-payment/getPaymentRefundUploadFileList`,
  downloadEmailNotificationUrl: `${baseUrl}/secure/email-sms-notification/{key}/download`,
  downloadUploadFileUrl: `${baseUrl}/secure/email-sms-notification/{key}/downloadFile`,
  downloadPaymentRefundTemplateUrl: `${baseUrl}/secure/refund-payment/template`,
  finalBulkPaymentRefundResults: `${baseUrl}/secure/refund-payment/finalBulkPaymentRefundResults`,

  initLotteryName: `${baseUrl}/secure/payment-settlement/lotteryName`,

  initBoardName: `${baseUrl}/secure/applicant-hearing/boardName`,
  getAccountOfficerConfirmedList: `${baseUrl}/secure/payment-settlement/{lotteryEventId}/{statusId}/accountOfficerConfirmedList`,
  getAccountOfficerFilterList: `${baseUrl}/secure/payment-settlement/{lotteryEventId}/{statusId}/accountOfficerFilterList`,
  viewPaymentDetail: `${baseUrl}/secure/payment-settlement/{applicationNo}`,
  getPaymentDetailsList: `${baseUrl}/secure/payment-settlement/{applicationNo}/paymentTableDetails`,
  processRefundInitFormUrl: `${baseUrl}/secure/process-refund/init`,
  initiateRefundProcess: `${baseUrl}/secure/process-refund/generateRefundReport/{key}`,
  refundReportDetailsInIt: `${baseUrl}/secure/process-refund/initRefundReportDetails/{lotteryKey}`,
  getRefundReport: `${baseUrl}/secure/process-refund/getRefundReport/{key}`,
  getPaymentRefundBeforePOLList: `${baseUrl}/secure/refund-payment/{lotteryEventId}/{statusId}/paymentRefundBeforePOLList`,
  viewaymentRefundDetail: `${baseUrl}/secure/refund-payment/{statusId}/{applicationNo}`,
  getPaymentRefundDetailsList: `${baseUrl}/secure/refund-payment/{applicationNo}/paymentTableDetails`,
  accountRefundApproveByClerk: `${baseUrl}/secure/refund-payment/accountRefundApproveByClerk`,
  accountRefundCloseByClerk: `${baseUrl}/secure/refund-payment/accountRefundCloseByClerk`,
  accountRefundApproveByAccount: `${baseUrl}/secure/refund-payment/accountRefundApproveByAccount`,
  accountRefundApproveByExpendature: `${baseUrl}/secure/refund-payment/accountRefundApproveByExpendature`,
  fetchRefundFileUploadByClerk: `${baseUrl}/secure/refund-payment/fetchOrderDocFile/{orderfile}/{applicationNo}`,
  rejectedPaymentRefund: `${baseUrl}/secure/refund-payment/rejectedPaymentRefund`,
  reopenPaymentRefund: `${baseUrl}/secure/refund-payment/reopenPaymentRefund`,
  downloadPaymentRefundUploadFileUrl: `${baseUrl}/secure/refund-payment/{key}/downloadFile`,
  downloadPaymentRefundUrl: `${baseUrl}/secure/refund-payment/{key}/download`,

  publishDocumentsInitFormUrl: `${baseUrl}/secure/estate-manager/publish-docs/init`,
  publishDocumentsFetchDocsForPublishUrl: `${baseUrl}/secure/estate-manager/publish-docs/fetch-docs-for-publish/{lotteryKey}/{docType}`,
  publishDocumentsUrl: `${baseUrl}/secure/estate-manager/publish-docs/publish-document/{lotteryKey}/{docType}`,
  publishDocumentsFetchPublishStatusUrl: `${baseUrl}/secure/estate-manager/publish-docs/publish-status/{lotteryKey}/{docType}`,

  dashBoardApplicationList: `${baseUrl}/open/home/init-dashboard`,
  exportMIS: `${baseUrl}/open/home/export-mis`,
  fetchMIS: `${baseUrl}/open/home/fetch-mis`,
  fetchReport: `${baseUrl}/secure/home/fetchReport`,
  fetchAsFile: `${baseUrl}/secure/tds-certificate/as-Certificate/{asFile}/{applicationNo}`,
  fetchForm16BFile: `${baseUrl}/secure/tds-certificate/form16B-Certificate/{asFile}/{applicationNo}`,
  fetchQbFile: `${baseUrl}/secure/tds-certificate/qbfile-Certificate/{asFile}/{applicationNo}`,
  fetchChallanFile: `${baseUrl}/secure/tds-certificate/challanFile-Certificate/{asFile}/{applicationNo}`,
  saveTdsStatus: `${baseUrl}/secure/tds-certificate/update/{applicationNo}`,
  accountOfficerApprove: `${baseUrl}/secure/payment-settlement/accountOfficerApprove/{applicationNo}`,

  saveRejectTdsStatus: `${baseUrl}/secure/tds-certificate/updateRejectStatus/{applicationNo}/{remark}`,
  paymentDashboard: `${baseUrl}/secure/payment-settlement/paymentDashboard`,

  // For Allotment Letter
  allotmentLetterList: `${baseUrl}/secure/allotment-Letter/list/{lotteryEventId}`,
  allotmentLetterGenerationDetail: `${baseUrl}/secure/allotment-Letter/{applicationNo}`,
  generateAllotmentLetter: `${baseUrl}/secure/allotment-Letter/generateAllotmentLetter/{applicationNo}`,
  getAllotmentLetter: `${baseUrl}/secure/allotment-Letter/getAllotmentLetter/{applicationNo}`,
  generateUnsignedPOL: `${baseUrl}/secure/letters/generate-unsigned-pol/{applicationId}`,
  generateUnsignedAllotmentLetter: `${baseUrl}/secure/letters/generate-unsigned-allotment-letter/{applicationId}`,
  viewDraftAllotmentLetter: `${baseUrl}/secure/letters/view-draft-allotment-letter/{applicationId}`,
  publishDraftAllotmentLetter: `${baseUrl}/secure/letters/publish-draft-allotment-letter/{applicationId}`,
  generateUnsignedPossessionLetter: `${baseUrl}/secure/letters/generate-unsigned-possession-letter/{applicationId}`,
  sendPossessionLetterForEsign: `${baseUrl}/secure/letters/send-possession-letter-for-esign/{applicationId}`,
  checkEsignStatusForPossession: `${baseUrl}/secure/letters/check-esign-status-for-possession/{applicationId}`,
  signPossessionLetterWithDSCUrl: `${baseUrl}/secure/letters/sign-possession-letter-with-dsc/{applicationId}`,
  checkPossessionDSCSignStatusUrl: `${baseUrl}/secure/letters/check-possession-letter-dsc-status/{applicationId}`,
  publishPossessionLetterUrl: `${baseUrl}/secure/letters/publish-possession-letter/{applicationId}`,

  signAllotmentLetterWithDSCUrl: `${baseUrl}/secure/letters/sign-allotment-letter-with-dsc/{applicationId}`,
  checkAllotmentDSCSignStatusUrl: `${baseUrl}/secure/letters/check-allotment-letter-dsc-status/{applicationId}`,
  publishAllotmentLetterUrl: `${baseUrl}/secure/letters/publish-allotment-letter/{applicationId}`,

  lotteryNameList: `${baseUrl}/secure/allotment-Letter/lotteryName`,
  downloadLettersUrl: `${baseUrl}/secure/download-all-letters/{applicationNo}`,
  fetchNOC: `${baseUrl}/secure/view-application/noc/{registrationId}/{applicationNo}`,
  fetchAllotment: `${baseUrl}/secure/view-application/allotment/{registrationId}/{applicationNo}`,
  fetchPossession: `${baseUrl}/secure/view-application/possession/{registrationId}/{applicationNo}`,
  fetchESign: `${baseUrl}/secure/view-application/eSign/{registrationId}/{applicationId}`,
  fetchIneligible: `${baseUrl}/secure/view-application/inEligible/{registrationId}/{applicationNo}`,
  fetchAcceptanceLetter: `${baseUrl}/secure/view-application/acceptanceLetter/{registrationId}/{applicationNo}`,
  fetchSurrenderLetter: `${baseUrl}/secure/view-application/surrenderLetter/{registrationId}/{applicationNo}`,
  fetchApplicationsESign: `${baseUrl}/secure/view-application/applicationESign/{registrationId}/{applicationId}`,
  schemeCodeList: `${baseUrl}/secure/allotment-Letter/schemeDetailsList/{lotteryEventId}`,
  fetchCorrigendumLetters: `${baseUrl}/secure/view-application/CorrigendumLetter/{registrationId}/{applicationNo}`,
  fetchfetchCastValiditys: `${baseUrl}/secure/view-application/castValidity/{registrationId}/{applicationId}`,

  lettersListInitUrl: `${baseUrl}/secure/letters/init`,
  lettersListFetchSchemeByLotteryUrl: `${baseUrl}/secure/letters/schemes/{lotteryEventId}`,
  lettersListFetchCategoryBySchemeUrl: `${baseUrl}/secure/letters/categories/{schemeId}`,
  lettersListFetchPageByFilterUrl: `${baseUrl}/secure/letters/page`,
  lettersListDownloadAllLetterUrl: `${baseUrl}/secure/letters/download-all-letter`,
  lettersListDownloadLetterUrl: `${baseUrl}/secure/letters/download-letter`,

  smsNotificationLotteryResultListFetchPageByFilterUrl: `${baseUrl}/secure/sms-not-lot-result/page`,
  smsNotificationLotteryResultSendSmsUrl: `${baseUrl}/secure/sms-not-lot-result/send-sms/{key}`,

  possesionDtlUpdateListFetchPageByFilterUrl: `${baseUrl}/secure/possession-dtl-update/page`,
  possesionDtlUpdateApplicationDetailUrl: `${baseUrl}/secure/possession-dtl-update/{applicationId}`,
  possesionDtlUpdateUrl: `${baseUrl}/secure/possession-dtl-update/{applicationId}`,
  revertpossisionLetter: `${baseUrl}/secure/possession-dtl-update/revertPossision`,

  //Applicant Details Edit
  fetchApplicantApprovePendingList: `${baseUrl}/secure/approve-pending/list`,
  fetchApplicantPhotoDetailBykey: `${baseUrl}/secure/approve-pending/{key}`,
  fetchApplicantMarriageStatusDetailBykey: `${baseUrl}/secure/approve-pending/marriageStatusDetail/{key}`,
  approveDetailForApplicant: `${baseUrl}/secure/approve-pending/approveStatus/{key}`,
  updateDetailsInApplicantTable: `${baseUrl}/secure/approve-pending/applicantMasterTable/{applicationNo}`,
  updateMarriageDetailsInApplicantTable: `${baseUrl}/secure/approve-pending/updateMarriageDetailsInApplicantTable/{applicationNo}`,
  fetchCaseDatass: `${baseUrl}/secure/view-application/mergeAllLetters/{registrationId}/{applicationId}`,
  downloadCorrigendumLetterUrl: `${baseUrl}/secure/view-application/CorrigendumLetters/{applicationNo}`,
  downloadCorrespondanceLetterUrl: `${baseUrl}/secure/view-application/CorrespondenceLetters/{applicationNo}`,
  downloadNomineeDocFileLetterUrl: `${baseUrl}/secure/view-application/nomineeDocFile/{applicationNo}`,
  downloadNomineeOrderFileLetterUrl: `${baseUrl}/secure/view-application/nomineeOrderFile/{applicationNo}`,

  blockchainApplicationListFetchPageByFilterUrl: `${baseUrl}/secure/block-chain/page`,
  blockchainViewDocumentUrl: `${baseUrl}/secure/block-chain/view-document/{blockchainId}`,
  verifyBlockchainFetchDetailUrl: `${baseUrl}/secure/block-chain/detail/{blockchainId}`,
  blockchainAuditTrailUrl: `${baseUrl}/secure/block-chain/audit-trail/{blockchainId}`,
  verifyBlockchainUrl: `${baseUrl}/secure/block-chain/verify/{blockchainId}`,
  fetchPendingBlockchainDocumentsUrl: `${baseUrl}/secure/block-chain/pending-doc-list`,

  blockchainDashboardUrl: `${baseUrl}/secure/block-chain/dashboard`,
  blockchainDashboardChartUrl: `${baseUrl}/secure/block-chain/dashboard-chart`,
  blockchainPushDocUrl: `${baseUrl}/secure/block-chain/push-bc-doc/{applicationNo}/{bcDocType}`,

  verifyBlockchainInitFormBoardListUrl: `${baseUrl}/secure/block-chain/init-form/boards`,
  verifyBlockchainInitFormLotteryListUrl: `${baseUrl}/secure/block-chain/init-form/boards/{boardId}/lotteries`,
  verifyBlockchainInitFormSchemeListUrl: `${baseUrl}/secure/block-chain/init-form/boards/{boardId}/lotteries/{lotteryId}/schemes`,

  getApplicantHearingList: `${baseUrl}/secure/applicant-hearing/{statusId}/applicantHearingList`,
  getChangeEligibilityList: `${baseUrl}/secure/applicant-hearing/getChangeEligibilityList`,
  getPaymentDefaulterList: `${baseUrl}/secure/applicant-hearing/getPaymentDefaulterList`,
  getRevertChangeEligibilityList: `${baseUrl}/secure/applicant-hearing/getRevertChangeEligibilityList`,
  getApplicantHearingFilterList: `${baseUrl}/secure/applicant-hearing/{statusId}/applicantHearingFilterList`,
  getChangeEligibilityFilterList: `${baseUrl}/secure/applicant-hearing/getChangeEligibilityFilterList`,
  getAppealButtonShowFilterList: `${baseUrl}/secure/applicant-hearing/getAppealButtonShowFilterList`,
  getRevertEligibilityFilterList: `${baseUrl}/secure/applicant-hearing/getRevertEligibilityFilterList`,
  getAppealButtonShowList: `${baseUrl}/secure/applicant-hearing/getAppealButtonShowList`,

  //Document Verification
  initDocVerLotteryName: `${baseUrl}/secure/document-verification/lotteryName`,
  getDocumentVerificationConfirmedList: `${baseUrl}/secure/document-verification/{lotteryEventId}/{statusId}/accountOfficerConfirmedList/{schemeId}`,
  getDocumentVerificationFilterList: `${baseUrl}/secure/document-verification/{lotteryEventId}/{statusId}/accountOfficerFilterList`,
  viewDocumentDetail: `${baseUrl}/secure/document-verification/{applicationNo}`,
  viewAuditDocDetail: `${baseUrl}/secure/document-verification/viewDetail/{applicationNo}`,
  getDocumentDetailsList: `${baseUrl}/secure/document-verification/{applicationNo}/paymentTableDetails`,
  beforAllotmentApproverDetail: `${baseUrl}/secure/document-verification/verify/{applicationNo}`,

  fetchAppealfile: `${baseUrl}/secure/applicant-hearing/fetchAppealfile/{appealfile}/{applicationNo}`,
  fetchAppealDocFile: `${baseUrl}/secure/applicant-hearing/fetchAppealDocFile/{appealDocfile}/{applicationNo}`,
  fetchOrderDocFile: `${baseUrl}/secure/applicant-hearing/fetchOrderDocFile/{orderfile}/{applicationNo}`,
  saveRejectAppeal: `${baseUrl}/secure/applicant-hearing/updateRejectAppeal`,
  saveEligibility: `${baseUrl}/secure/applicant-hearing/saveEligibility`,
  savePaymentDefaulter: `${baseUrl}/secure/applicant-hearing/savePaymentDefaulter`,
  saveRevertEligibility: `${baseUrl}/secure/applicant-hearing/saveRevertEligibility`,
  viewAppealDetail: `${baseUrl}/secure/applicant-hearing/{applicationNo}/{appealType}`,
  saveAppealHearing: `${baseUrl}/secure/applicant-hearing/saveAppealHearing`,
  saveAppealApprove: `${baseUrl}/secure/applicant-hearing/saveAppealApprove/{applicationNo}/{remark}`,
  fetchInstallmentType: `${baseUrl}/secure/applicant-hearing/fetchInstallmentType/{applicationNo}/{appealType}`,
  viewInstallmentType: `${baseUrl}/secure/applicant-hearing/viewInstallmentType/{applicationNo}`,
  saveApprovedDocument: `${baseUrl}/secure/applicant-hearing/saveApprovedDocument`,
  saveApprovedPayment: `${baseUrl}/secure/applicant-hearing/saveApprovedPayment`,
  saveAppealButton: `${baseUrl}/secure/applicant-hearing/saveAppealButton`,

  getBeforePolDocumentVerificationConfirmedList: `${baseUrl}/secure/document-verification/{lotteryEventId}/{statusId}/beforePolConfirmedList`,
  getBeforePolDocumentVerificationFilterList: `${baseUrl}/secure/document-verification/{lotteryEventId}/{statusId}/beforePolFilterList`,
  viewPolDocumentDetail: `${baseUrl}/secure/document-verification/pol/{applicationNo}`,
  beforPolApproverDetail: `${baseUrl}/secure/document-verification/verifyPol/{applicationNo}`,
  initDocVerSchemeName: `${baseUrl}/secure/document-verification/schemeName`,
  initDocVerSchemeList: `${baseUrl}/secure/document-verification/schemeName/schemeList/{lotteryEventId}`,
  getFilterList: `${baseUrl}/secure/document-verification/filterList`,

  refreshDashboard: `${baseUrl}/open/home/refresh-dashboard-mview`,

  fetchAgreementUnSignedCopyLetter: `${baseUrl}/secure/view-application/agreementUnSignedCopy/{registrationId}/{applicationNo}`,

  fetchAgreementCopyLetter: `${baseUrl}/secure/view-application/agreementCopy/{registrationId}/{applicationNo}`,
  fetchIndex2Letter: `${baseUrl}/secure/view-application/index2/{registrationId}/{applicationNo}`,
  importDocumentsUrl: `${baseUrl}/secure/document-verification/importdocument/{lotteryKey}/{type}`,
  fetchAffidavit: `${baseUrl}/secure/view-application/affidavit/{registrationId}/{applicationId}`,
  fetchPossessionsreceipt: `${baseUrl}/secure/view-application/possessionsreceipt/{registrationId}/{applicationId}`,
  fetchKeyhandoverphoto: `${baseUrl}/secure/view-application/keyhandoverphoto/{registrationId}/{applicationId}`,
  updatepossisionComplete: `${baseUrl}/secure/document-verification/possisionComplete`,
  getEngineerDocumentVerificationConfirmedList: `${baseUrl}/secure/document-verification/{lotteryEventId}/{statusId}/engineerConfirmedList`,

  fetchDraftAllotmentLetters: `${baseUrl}/secure/view-application/draftAllotmentLetter/{registrationId}/{applicationNo}`,
  downloadCastValidityLetterURLs: `${baseUrl}/secure/view-application/downloadCastValidityLetter/{boardId}/{lotteryId}/{startDate}/{endDate}`,
  generetePossessionReceipt: `${baseUrl}/secure/letters/generate-possession-receipt/{applicationNo}`,
  fetchPossessionReceiptFormat: `${baseUrl}/secure/view-application/possessionReceiptFormat/{registrationId}/{applicationNo}`,
  //Tenement Exchange
  tenementList: `${baseUrl}/secure/tenement-exchange/list`,
  viewTenementDetail: `${baseUrl}/secure/tenement-exchange/{applicationId}`,
  fetchOtp: `${baseUrl}/secure/tenement-exchange/fetchOtpForExchange/{fromApplicationNo}/{toApplicationNo}/{vacantTenementId}/{exchangeType}`,
  resendFetchOtp: `${baseUrl}/secure/tenement-exchange/resendFetchOtpForExchange/{fromApplicationNo}/{toApplicationNo}/{vacantTenementId}/{exchangeType}`,
  notAllowedTenement: `${baseUrl}/secure/tenement-exchange/listNotAllowedTenement`,
  saveExchangedTenement: `${baseUrl}/secure/tenement-exchange/save`,
  otpVerificationForExchangeTenement: `${baseUrl}/secure/tenement-exchange/otpVerificationForExchange/{fromApplicationNo}/{toApplicationNo}`,

  //Upload Tenement Master
  downloadTemplate: `${baseUrl}/secure/upload-tenement-master/template/{type}`,
  getLotteriesForBoard: `${baseUrl}/secure/upload-tenement-master/{boardId}`,
  saveMasterDetails: `${baseUrl}/secure/upload-tenement-master/save`,
  updateMasterDetails: `${baseUrl}/secure/upload-tenement-master/update`,
  fetchtenementMasterList: `${baseUrl}/secure/upload-tenement-master/list`,
  fetchEditDetails: `${baseUrl}/secure/upload-tenement-master/fetch/{key}`,
  deleteMasterEntry: `${baseUrl}/secure/upload-tenement-master/delete/{key}`,

  // officials
  officialsListInitUrl: `${baseUrl}/secure/officials/init`,
  officialsListFetchSchemeByLotteryUrl: `${baseUrl}/secure/officials/schemes/{lotteryEventId}`,
  officialsListFetchPageByFilterUrl: `${baseUrl}/secure/officials/page`,
  updateCasteValidity: `${baseUrl}/secure/officials/{appId}`,

  dashboardDataEntryList: `${baseUrl}/secure/dashboard/dataentry/list`,
  initDashboardDataEntryFormUrl: `${baseUrl}/secure/dashboard/dashboard-dataentry/form`,
  dashboardDataEntryDetail: `${baseUrl}/secure/dashboard/dashboard-dataentry/{dashboardKey}`,
  dashboardSumbitData: `${baseUrl}/secure/dashboard/submitData/{dashboardKey}`,
  changeBoardURLs: `${baseUrl}/secure/new-lottery/changeBoard/{boardId}`,
  resetProfileURLs: `${baseUrl}/secure/reset-profile/resetProfile/{panNumber}`,
  getAuditTrail: `${baseUrl}/secure/document-verification/auditTrail`,
  generateDashboardReport: `${baseUrl}/secure/dashboard/notify/notifyDashboard/{type}/{generationDate}`,
  fetchPossessionReceiptUrl: `${baseUrl}/secure/view-application/possessionsreceipt/{registrationId}/{applicationId}`,
  fetchPossessionAffidavitUrl: `${baseUrl}/secure/view-application/affidavit/{registrationId}/{applicationId}`,

  // PAYMENT EXTENSION
  getPaymentExtensionList: `${baseUrl}/secure/payment-extension/page`,
  fetchPaymentDetails: `${baseUrl}/secure/payment-extension/{applicationNo}/payment-details`,
  paymentExtensionListInitUrl: `${baseUrl}/secure/payment-extension/init`,
  savePaymentExtension: `${baseUrl}/secure/payment-extension/save`,
  downloadKeyHandOverPhotoServiceUrl: `${baseUrl}/secure/view-application/keyHandOverPhoto/{registrationId}/{applicationId}`,
  fetchMarriageCertificateUrl: `${baseUrl}/secure/view-application/marriageCertificate/{registrationId}/{applicationId}`,
  fetchotherAffidaviteDocUrl: `${baseUrl}/secure/view-application/otherAffidaviteDoc/{registrationId}/{applicationId}`,
  fetchNameChangeGazetteUrl: `${baseUrl}/secure/view-application/nameChangeGazette/{registrationId}/{applicationId}`,
  downloadApplicationCountReportURLs: `${baseUrl}/secure/application-data-report/generate-report-count`,
  downloadWinnerApplicationListReportURLs: `${baseUrl}/secure/application-data-report/generate-report-winner-applicant-list`,
  downloadWaitListApplicationListReportURLs: `${baseUrl}/secure/application-data-report/generate-report-waitlist-applicant-list`,
  downloadNonWinnerApplicationListReportURLs: `${baseUrl}/secure/application-data-report/generate-report-nonwinner-applicant-list`,
  downloadTotalApplicationRecievedListReportURLs: `${baseUrl}/secure/application-data-report/generate-report-application-recieved-list`,
  downloadEMDPaidApplicationListReportURLs: `${baseUrl}/secure/application-data-report/generate-report-emd-list`,
  downloadVacantTenementListReportURLs: `${baseUrl}/secure/application-data-report/generate-report-vacantTenement-list`,
  fetchOfficialCasteValidityUrl: `${baseUrl}/secure/view-application/officialCasteValidity/{registrationId}/{applicationId}`,
  fetchSpousePanDetailsURLs: `${baseUrl}/secure/update-panname/fetchBeforeUpdatePanDetails/panDetails/{applicationNo}`,
  updateSpousePanDetails: `${baseUrl}/secure/update-panname/fetchPanDetails`,
  fetchSelfAadharUpdateURLs: `${baseUrl}/secure/update-panname/fetchAadharPhoto/{applicationNo}`,
  fetchAadharBackPhotoServiceURLs: `${baseUrl}/secure/update-panname/fetchAadharPhoto/backPhoto/{applicationNo}`,
  fetchSchemeListURLs: `${baseUrl}/secure/ebilling-data-report/scheme-list/{lotteryId}`,
  DownloadEBillingReportURLs: `${baseUrl}/secure/ebilling-data-report/generate-ebillingreport-count`,
  changeAadharPhotoURLs: `${baseUrl}/secure/update-panname/changeAadharPhoto`,
  fetchSpouseAadharUpdateURLs: `${baseUrl}/secure/update-panname/fetchSpouseAadharFrontPhoto/{applicationNo}`,
  fetchSpouseAadharBackPhotoServiceURLs: `${baseUrl}/secure/update-panname/fetchSpouseAadharBackPhoto/backPhoto/{applicationNo}`,
  changeApplicantAadharPhotoURLs: `${baseUrl}/secure/update-panname/changeSpouseAadharPhoto`,
  downloadProjectTenementURLs: `${baseUrl}/secure/projectTenement/list/{boardId}`,
  downloadProjectImages: `${baseUrl}/secure/projectTenement/images/{key}`,
  getProjectDetails: `${baseUrl}/secure/projectTenement/projectDetail/{boardId}`,
  appealUploadedDocumentUrl: `${baseUrl}/secure/view-application/appealOrderedDocument/{registrationId}/{applicationId}`,
  fetchApplicantMobileNumberServiceURLs: `${baseUrl}/secure/update-panname/fetchApplicantMobileNumber/mobileNumber/{applicationNo}`,
  updateApplicationMobileNumberURLs: `${baseUrl}/secure/update-panname/updateApplicationMobileNumber`,
  fetchApplicantEmailServiceURLs: `${baseUrl}/secure/update-panname/fetchApplicantEmailId/email/{applicationNo}`,
  updateApplicationEmailIdServiceURLs: `${baseUrl}/secure/update-panname/updateApplicationEmailId`,
  fetchSpouseEmailIdServiceURLs: `${baseUrl}/secure/update-panname/fetchSpouseEmailId/spouseEmailId/{applicationNo}`,
  updateSpouseEmailIdServiceURLs: `${baseUrl}/secure/update-panname/updateSpouseEmailId`,
  getSurrReqVerificationFilterList: `${baseUrl}/secure/surr-req-verification/{lotteryEventId}/{statusId}/surrReqVeriList/{schemeId}`,
  getSurrReqVerificationFilterTxtList: `${baseUrl}/secure/payment-settlement/{lotteryEventId}/{statusId}/accountOfficerFilterList`,
  viewDocumentDetailForSurrReq: `${baseUrl}/secure/surr-req-verification/{applicationNo}/{surrReqKey}`,
  submitSurrReqVerificationSts: `${baseUrl}/secure/surr-req-verification/verify/{applicationNo}`,
  fetchSurrReqFile: `${baseUrl}/secure/view-application/surrReqFile/{registrationId}/{applicationNo}/{reqLtrFile}`,
  uploadCorresponceDocServiceURLs: `${baseUrl}/secure/view-application/uploadCorrespondance`,
  // fetchUploadedCorrespondenceLetterUrl: `${baseUrl}/secure/view-application/fetchUploadedCorrespondence/{registrationId}/{applicationId}`,

  lotteryEventList: `${baseUrl}/secure/reports/lotteryEventList/{boardId}`,
  lotterysList: `${baseUrl}/secure/reports/lotteryNameList/{selectedYear}/{boardKey}`,
  fetchRoleList: `${baseUrl}/secure/reports/fetchRoleList`,
  revertallotmentLetter: `${baseUrl}/secure/possession-dtl-update/revertAllotment`,
  initAllBoardForInvoice: `${baseUrl}/secure/invoice/init`,
  initLotteryForInvoice: `${baseUrl}/secure/invoice/init-lottery/{key}`,
  invoiceList: `${baseUrl}/secure/invoice/stage`,
  saveInvoiceDetails: `${baseUrl}/secure/invoice/save-invoicedetails`,
  submittedInvoiceData: `${baseUrl}/secure/invoice/invoice-data`,
  deleteInvoiceRecord: `${baseUrl}/secure/invoice/{key}`,
  countOfStages: `${baseUrl}/secure/invoice/stagesCounts`,
  countByInvoice: `${baseUrl}/secure/invoice/countByInvoice`,
  setInvoiceNumber: `${baseUrl}/secure/invoice/setInvoiceNumber`,
  invoiceNumberDetails: `${baseUrl}/secure/invoice/invoiceNumber-details`,
  fetchInvoiceDetails: `${baseUrl}/secure/invoice/fetchInvoiceDetails`,
  saveSettledInvoice: `${baseUrl}/secure/invoice/saveSettledInvoice`,
  fetchInvoiceCountReceipt: `${baseUrl}/secure/invoice/countByInvoice`,
  fetchInvoiceReceipt: `${baseUrl}/secure/invoice/fetchInvoiceReceipt`,
  cancelInvoice: `${baseUrl}/secure/invoice/cancelInvoice`,
  downloadInvoiceReceipt: `${baseUrl}/secure/invoice/downloadInvoiceReceipt`,
  downloadApplicantDocsURLs: `${baseUrl}/secure/view-application/downloadDocZipFile/{boardId}/{lotteryId}/{schemeId}`,
  changeBoardForPmayLotteryURLs: `${baseUrl}/secure/new-lottery/changeBoardPmayLottery/{boardId}`,

  //New Payment Extension
  getNewPaymentExtensionList: `${baseUrl}/secure/new-payment-extension/page`,
  //fetchPaymentDetails: `${baseUrl}/secure/new-payment-extension/{applicationNo}/payment-details`,
  installmentConfigIniLotteryUrl: `${baseUrl}/secure/new-payment-extension/init/{lotteryKey}`,
  newPaymentExtensionListInitUrl: `${baseUrl}/secure/new-payment-extension/init`,
  saveNewPaymentExtension: `${baseUrl}/secure/new-payment-extension/save`,
  installmentConfigInitWithSchemeSelectUrl: `${baseUrl}/secure/new-payment-extension/init/{lotteryKey}/{schemeKey}`,

  getAdvAdvertisementsUrl: `${baseUrl}/secure/adv/advertisements`,
  saveAdvAdvertisementsUrl: `${baseUrl}/secure/adv/advertisements`,
  getAdvLotteriesByBoardUrl: `${baseUrl}/secure/adv/lotteries/{boardId}`,
  getAdvLotteryDetailUrl: `${baseUrl}/secure/adv/lottery/{id}`,
  getAdvAdvertisementBoardsUrl: `${baseUrl}/secure/adv/boards`,
  deleteAdvAdvertisementsUrl: `${baseUrl}/secure/adv/advertisements/{id}`,
  getAdvAdvertisementDetailUrl: `${baseUrl}/secure/adv/advertisements/{id}`,
  updateAdvAdvertisementUrl: `${baseUrl}/secure/adv/advertisements`,

  getMomMeetingTypeUrl: `${baseUrl}/secure/mom/meetingTypes/{id}`,
  deleteMomMeetingTypeUrl: `${baseUrl}/secure/mom/meetingTypes/{id}`,
  saveMomMeetingTypeUrl: `${baseUrl}/secure/mom/meetingTypes`,
  updateMomMeetingTypeUrl: `${baseUrl}/secure/mom/meetingTypes`,
  getMomMeetingTypesUrl: `${baseUrl}/secure/mom/meetingTypes`,

  getMeetingsByUserIdUrl: `${baseUrl}/secure/mom/getMeetingsByUserId`,
  getArchieveMeetingUrl: `${baseUrl}/secure/mom/getArchieveMeeting`,
  getLotteriesByBoardUrl: `${baseUrl}/secure/mom/lotteriesByBoard/{id}`,
  getMomBoardsUrl: `${baseUrl}/secure/mom/boards`,
  getMeetingsUrl: `${baseUrl}/secure/mom/meetings`,
  getMeetingsByIdUrl: `${baseUrl}/secure/mom/meetings/{id}`,
  getMomLotteriesUrl: `${baseUrl}/secure/mom/lotteries`,
  saveMomMeetingsUrl: `${baseUrl}/secure/mom/meetings`,
  updateMomMeetingsUrl: `${baseUrl}/secure/mom/meetings`,
  momMediaUploadUrl: `${baseUrl}/secure/mom/media`,
  momHtmlToPdfUrl: `${baseUrl}/secure/mom/htmlToPDF`,
  updateRecordMeetingUrl: `${baseUrl}/secure/mom/updateRecordMeeting`,
  meetingApprovedWithPDFUrl: `${baseUrl}/secure/mom/meetingApprovedWithPDF`,
  updateCorrectionMeetingUrl: `${baseUrl}/secure/mom/updateCorrectionMeeting/{meetingId}`,
  getMeetingsByStatusUrl: `${baseUrl}/secure/mom/meetingsByStatus/{status}`,
  getMomUserByEmailIdUrl: `${baseUrl}/secure/mom/users/{email}`,
  getApproverMeetingsByUserIdUrl: `${baseUrl}/secure/mom/getApproverMeetingsByUserId`,

  tenementInsConfigInitFormUrl: `${baseUrl}/secure/tenement-installment-config/init`,
  initWithScheme: `${baseUrl}/secure/tenement-installment-config/initWithScheme/{lotteryKey}/{schemeKey}`,
  initWithBldg: `${baseUrl}/secure/tenement-installment-config/initWithBldg/{lotteryKey}/{schemeKey}/{bldg}`,
  initWithWing: `${baseUrl}/secure/tenement-installment-config/initWithWing/{lotteryKey}/{schemeKey}/{bldg}/{wing}`,
  initWithFloor: `${baseUrl}/secure/tenement-installment-config/initWithFloor/{lotteryKey}/{schemeKey}/{bldg}/{wing}/{floor}`,
  getAllTenementDtls: `${baseUrl}/secure/tenement-installment-config/getAllTenementDtls`,
  getConfigOfTenement: `${baseUrl}/secure/tenement-installment-config/getConfigOfTenement/{key}`,
  saveTenementConfig: `${baseUrl}/secure/tenement-installment-config/saveTenementConfig`,
  checkConfigOfTenements: `${baseUrl}/secure/tenement-installment-config/checkConfigOfTenements`,
  getConfigurationDetailsOfTenementForEdit: `${baseUrl}/secure/tenement-installment-config/getConfigurationDetailsOfTenementForEdit/{key}`,
  updateTenementConfig: `${baseUrl}/secure/tenement-installment-config/updateTenementConfig`,
  getDocumentFile: `${baseUrl}/secure/tenement-installment-config/getDocumentFile/{tenementConfigKey}/{tenementKey}`,
  fetchPaymentDefaulterReport: `${baseUrl}/secure/applicant-hearing/fetchPaymentDefaulterReport`,
  addNomineeApplicationSearch: `${baseUrl}/secure/add-nominee/search`,
  viewNomineeForm: `${baseUrl}/secure/add-nominee/view-form/{applicationId}`,
  saveNomineeDtls: `${baseUrl}/secure/add-nominee/saveNomineeDtls`,
  generateNomineeUnsignedPOL: `${baseUrl}/secure/add-nominee/generate-unsigned-pol/{applicationId}`,
  generateNomineeUnsignedAllotmentLetter: `${baseUrl}/secure/add-nominee/generate-unsigned-allotment-letter/{applicationId}`,
  generateNomineeUnsignedPossessionLetter: `${baseUrl}/secure/add-nominee/generate-unsigned-possession-letter/{applicationId}`,
  initLotteryEventForRevertActdWlt: `${baseUrl}/secure/activewaitlist/reverse`,
  fetchRejectedSelfAadharUpdateURLs: `${baseUrl}/secure/update-panname/fetchRejectedAadharPhoto/{applicationNo}`,
  fetchRejectedAadharBackPhotoServiceURLs: `${baseUrl}/secure/update-panname/fetchRejectedAadharPhoto/backPhoto/{applicationNo}`,
  changeRejectedAadharPhotoURLs: `${baseUrl}/secure/update-panname/changeRejectedAadharPhoto`,
  getAppDtls: `${baseUrl}/secure/activewaitlist/getAppDtls`,
  revertWaitlist: `${baseUrl}/secure/activewaitlist/reverse`,
  
// Scheme - Editor  
  initLotteryEventForSchemeEditor: `${baseUrl}/secure/nodal/init`,
  schemeEditorListFetchPageByFilterUrl: `${baseUrl}/secure/nodal/page`,
  toggleActivationSchemeUrl: `${baseUrl}/secure/nodal/{key}`,
  schemeInActiveSendOtpUrl: `${baseUrl}/secure/nodal/send-otp/{key}`,
  schemeInActiveVerifyOtpUrl: `${baseUrl}/secure/nodal/otp-verification/{key}`,

  
  //Extend Surrender
  extendSurrenderInitFormUrl: `${baseUrl}/secure/extendSurrender/init`,
  extendSurrenderInitWithLotteryUrl: `${baseUrl}/secure/extendSurrender/init/{lotteryKey}`,
  getLotteryandSchemeDataForSurrender: `${baseUrl}/secure/extendSurrender/initWithLotteryAndScheme`,
  updateSurrenderDtl: `${baseUrl}/secure/extendSurrender/updateSurrenderDtl`,
  generateOtpforSurrender: `${baseUrl}/secure/extendSurrender/resendFetchOtpForSurrenderDateExtend`,
  generateOtpforRvrtWtlst: `${baseUrl}/secure/activewaitlist/resendFetchOtpForRevertWaitlist/{oprtAppNo}`,
  getDtlsOfOprtdApp: `${baseUrl}/secure/activewaitlist/getDtlsOfOprtdApp`,

  profileDetailsUrl: `${baseUrl}/secure/profile-details/{pan}`,
  fetchRegPhotoUrl: `${baseUrl}/secure/profile-details/{pan}/photo`,
  fetchQuestionDocUrl: `${baseUrl}/secure/profile-details/{pan}/question-doc/{questionCode}`,
  ictDashboardInitUrl: `${baseUrl}/secure/ict-dashboard/init`,
  ictDashboardInnerInitUrl: `${baseUrl}/secure/ict-dashboard/filter`,
  ictDashboardInnerDetailUrl: `${baseUrl}/secure/ict-dashboard/detail`
};
